import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { ModelListVM } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './models-vm.actions';

interface ModelsState {
    modelList: Loadable<ModelListVM>;
}

const initialState: ModelsState = {
    modelList: null,
};

export const state = createFeature({
    name: 'modelsVM',
    reducer: createReducer(
        initialState,
        on(
            actions.loadModelVMList,
            (state): ModelsState => ({
                ...state,
                modelList: null,
            }),
        ),
        on(
            actions.loadModelVMListSuccess,
            (state, { modelList }): ModelsState => ({
                ...state,
                modelList,
            }),
        ),
        on(
            actions.loadModelVMListFailure,
            (state): ModelsState => ({
                ...state,
                modelList: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingModelList = createSelector(
            baseSelectors.selectModelList,
            (modelList) => modelList === null,
        );
        const selectLoadedModelList = createSelector(
            baseSelectors.selectModelList,
            (modelList) => modelList as Loaded<ModelListVM>,
        );

        return {
            selectIsLoadingModelList,
            selectLoadedModelList,
        };
    },
});
